(function(){

  // console.log("✅ predictive-search.js loaded");

  const input   = document.getElementById('nav-quick-search');
  const results = document.querySelector('.quickSearchResults');
  const form    = results?.closest('.search-panel')?.querySelector('form');
  // if (!input || !results || !form) return;

  const moneyFmt = (cents) => {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, Shopify.money_format || '${{amount}}');
      }
    } catch(e){}
    return (Number(cents)/100).toFixed(2);
  };

  let controller = null;
  let activeIndex = -1;

  function openDropdown(){ results.classList.add('is-open'); }
  function closeDropdown(){ results.classList.remove('is-open'); activeIndex = -1; }
  function clearResults(){ results.innerHTML = ''; closeDropdown(); }

  function setActive(index){
    const items = results.querySelectorAll('.ps-item');
    items.forEach((el,i)=> el.setAttribute('aria-selected', String(i === index)));
    activeIndex = index;
    if (items[index]) {
      const el = items[index];
      const rTop = results.scrollTop;
      const rBot = rTop + results.clientHeight;
      const eTop = el.offsetTop;
      const eBot = eTop + el.offsetHeight;
      if (eTop < rTop) results.scrollTop = eTop;
      else if (eBot > rBot) results.scrollTop = eBot - results.clientHeight;
    }
  }

  // 🟢 FIX: helper moved inside closure
  function ensureFirstActive() {
    const items = results.querySelectorAll('.ps-item');
    if (items.length && activeIndex === -1) setActive(0);
  }

  function getSuggestUrl(q){
    const base = '/search/suggest.json';
    const u = new URL(base, location.origin);
    u.searchParams.set('q', q);
    // u.searchParams.set('resources[type]', 'product,collection,article,page');
    u.searchParams.set('resources[type]', 'product');
    u.searchParams.set('resources[limit]', '10');
    u.searchParams.set('section_id', 'predictive-search');
    return u.toString();
  }

  async function fetchSuggest(q){
    if (controller) controller.abort();
    controller = new AbortController();
    // console.log("Hello there "+q);
    if(q!="")
    {
      const url = getSuggestUrl(q);
    // console.log('Predictive Search URL:', url);
    const res = await fetch(url, { signal: controller.signal, headers: { 'Accept': 'application/json' }});
    if (!res.ok) throw new Error('Network error');
    return res.json();
    }
    
  }

  function render(data, q){
  const resources   = data?.resources || {};
  // If your store returns nested ".results", use the optional chaining below:
  const products    = resources.results?.products?.results || resources.results?.products || [];

  // Build header + list
  let html = `

    <div class="ps-head custom-close-predictive ps-clear">
        <button type="button" class="ps-close modal-close" aria-label="Close">×</button>
    </div>
   
    <ul class="ps-list" role="listbox">
      ${products.map((p) => {
        const img = (p.image?.url || p.image || p.featured_image?.url || '');
        const priceCents = (p.price_min ?? p.price ?? p.variants?.[0]?.price ?? null);
        const price = priceCents != null ? moneyFmt(priceCents) : '';
        const url = p.url || (p.handle ? `/products/${p.handle}` : '#');
        const title = p.title || '';
        return `
          <li class="ps-item" role="option" tabindex="-1" data-url="${url}">
            <img class="ps-item__img" src="${img}" alt="${title.replace(/"/g,'&quot;')}">
            <div class="custom-title-price-div">
              <div class="ps-item__title">${title}</div>
              <div class="ps-item__price">${price}</div>
            </div>
            
          </li>
        `;
      }).join('')}
    </ul>
  `;

  if (!products.length){
    results.innerHTML = `
      
      <div class="ps-empty" style="padding:12px;">No results for “${q.replace(/</g,'&lt;')}”</div>
    `;
    openDropdown();
    results.querySelector('.ps-close')?.addEventListener('click', closeDropdown);
    return;
  }

  // footer actions
  

  results.innerHTML = html;
  openDropdown();

  // interactions
  results.querySelector('.ps-close')?.addEventListener('click', closeDropdown);

  results.querySelectorAll('.ps-item').forEach((el, i) => {
    el.addEventListener('mouseenter', () => setActive(i));
    el.addEventListener('mouseleave', () => setActive(-1));
    el.addEventListener('click', () => {
      const url = el.getAttribute('data-url');
      if (url) window.location.href = url;
    });
  });

  const clearBtn = results.querySelector('.ps-clear');
  if (clearBtn) clearBtn.addEventListener('click', () => {
    input.value = '';
    clearResults();
    input.focus();
  });
}


  

  // Debounce typing
  let t = null;
  input.addEventListener('input', () => {
    const q = input.value.trim();
    if (!q){ clearResults(); return; }
    window.clearTimeout(t);
    t = window.setTimeout(async () => {
      try {
        const data = await fetchSuggest(q);
        render(data, q);
      } catch (e) {
        clearResults();
      }
    }, 200);
  });

  // Keyboard navigation
  input.addEventListener('keydown', (e) => {
    const items = results.querySelectorAll('.ps-item');
    const open = results.classList.contains('is-open');
    if (!open || !items.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      ensureFirstActive();
      setActive(Math.min(activeIndex + 1, items.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      ensureFirstActive();
      setActive(activeIndex > 0 ? activeIndex - 1 : items.length - 1);
    } else if (e.key === 'Enter') {
      if (activeIndex >= 0 && items[activeIndex]) {
        e.preventDefault();
        const url = items[activeIndex].getAttribute('data-url');
        if (url) window.location.href = url;
      }
    } else if (e.key === 'Escape') {
      closeDropdown();
    }
  });

  // Close on outside click / blur
  document.addEventListener('click', (e) => {
    if (!results.classList.contains('is-open')) return;
    const panel = results.closest('.search-panel');
    if (panel && !panel.contains(e.target)) closeDropdown();
  });

  // Submit fallback
  form.addEventListener('submit', () => closeDropdown());
})();
